import styled from 'styled-components';

export const Container = styled.section`
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-wrap: wrap;
  column-gap: 6px;
  row-gap: 6px;
  margin: 80px auto 0 auto;

  @media screen and (max-width: 720px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
`;

export const Button = styled.button.attrs({ type: 'button' })`
  transition: 300ms ease;

  img {
    width: 100%;
  }

  &:hover {
    transform: scale(0.95);
  }
`;
